import { render, staticRenderFns } from "./Arhiva.vue?vue&type=template&id=68fdcab8&scoped=true&"
import script from "./Arhiva.vue?vue&type=script&lang=js&"
export * from "./Arhiva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fdcab8",
  null
  
)

export default component.exports